"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuBar = void 0;
var core_1 = require("@material-ui/core");
var React = require("react");
var recoil_1 = require("recoil");
var lib_1 = require("typestyle/lib");
var Colorize_1 = require("../icons/Colorize");
var Edit_1 = require("../icons/Edit");
var Edit1_1 = require("../icons/Edit1");
var Edit2_1 = require("../icons/Edit2");
var Edit3_1 = require("../icons/Edit3");
var Edit4_1 = require("../icons/Edit4");
var Edit5_1 = require("../icons/Edit5");
var Eraser_1 = require("../icons/Eraser");
var Eraser1_1 = require("../icons/Eraser1");
var Eraser2_1 = require("../icons/Eraser2");
var Eraser3_1 = require("../icons/Eraser3");
var Eraser4_1 = require("../icons/Eraser4");
var Eraser5_1 = require("../icons/Eraser5");
var FormatPaint_1 = require("../icons/FormatPaint");
var Nib1_1 = require("../icons/Nib1");
var Nib2_1 = require("../icons/Nib2");
var Nib3_1 = require("../icons/Nib3");
var Nib4_1 = require("../icons/Nib4");
var Nib5_1 = require("../icons/Nib5");
var recoils_1 = require("../recoils");
var IconButton_1 = require("./IconButton");
var Paper_1 = require("./Paper");
var root = lib_1.style({
    margin: 16,
    marginBottom: 8,
    height: 56,
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
});
var NibIcons = [React.Fragment, Nib1_1.default, Nib2_1.default, Nib3_1.default, Nib4_1.default, Nib5_1.default];
function MenuBar() {
    var _a = __read(recoil_1.useRecoilState(recoils_1.cursorModeState), 2), cursorMode = _a[0], setCursorMode = _a[1];
    var _b = __read(recoil_1.useRecoilState(recoils_1.paletteSelectionState), 2), selection = _b[0], setSelection = _b[1];
    var palettePageLoadable = recoil_1.useRecoilValueLoadable(recoils_1.palettePagesState);
    var _c = __read(recoil_1.useRecoilState(recoils_1.nibWidthState), 2), nibWidth = _c[0], setNibWidth = _c[1];
    var _d = __read(recoil_1.useRecoilState(recoils_1.eraserWidthState), 2), eraserWidth = _d[0], setEraserWidth = _d[1];
    var _e = __read(React.useState(), 2), nibAnchorEl = _e[0], setNibAnchorEl = _e[1];
    var handlePen = React.useCallback(function (e) {
        if (cursorMode === 'pen') {
            // ペンモードでもう一度アイコンを押すと大きさを変えられる
            setNibAnchorEl(e.currentTarget);
            return;
        }
        if (selection === null) {
            // 一番左上のひとつ右隣を自動的に選ぶ
            var pages = palettePageLoadable.state === 'hasValue'
                ? palettePageLoadable.contents
                : undefined;
            if (!pages)
                return; // type hint
            var pos = { row: 0, col: 1, num: 1 };
            setSelection({
                page: pages[0].index,
                start: pos,
                end: pos
            });
            setNibWidth(1);
        }
        setCursorMode('pen');
    }, [cursorMode, selection, palettePageLoadable]);
    var _f = __read(React.useState(), 2), eraserAnchorEl = _f[0], setEraserAnchorEl = _f[1];
    var handleEraser = React.useCallback(function (e) {
        if (cursorMode === 'eraser') {
            // 消しゴムモードでもう一度アイコンを押すと大きさを変えられる
            setEraserAnchorEl(e.currentTarget);
            return;
        }
        setCursorMode('eraser');
    }, [cursorMode]);
    var handleBase = React.useCallback(function () {
        setCursorMode('base');
    }, []);
    var handleDropper = React.useCallback(function () {
        setCursorMode('dropper');
    }, []);
    // cursorMode が変わったらペンと消しゴムの太さを元に戻す
    React.useEffect(function () {
        setNibWidth(1);
        setEraserWidth(1);
    }, [cursorMode]);
    return (React.createElement(Paper_1.Paper, { id: "rme-menu-bar", className: root },
        React.createElement(IconButton_1.IconButton, { active: cursorMode === 'pen', label: "\u3048\u3093\u3074\u3064", margin: true, disabled: palettePageLoadable.state !== 'hasValue', onClick: handlePen }, nibWidth === 1 ? (React.createElement(Edit1_1.default, null)) : nibWidth === 2 ? (React.createElement(Edit2_1.default, null)) : nibWidth === 3 ? (React.createElement(Edit3_1.default, null)) : nibWidth === 4 ? (React.createElement(Edit4_1.default, null)) : nibWidth === 5 ? (React.createElement(Edit5_1.default, null)) : (React.createElement(Edit_1.default, null))),
        React.createElement(core_1.Menu, { open: Boolean(nibAnchorEl), anchorEl: nibAnchorEl, onClose: function () { return setNibAnchorEl(undefined); } }, NibIcons.map(function (Icon, size) {
            return size === 0 ? null : (React.createElement(core_1.MenuItem, { key: size, selected: nibWidth === size, onClick: function () {
                    setNibWidth(size);
                    setNibAnchorEl(undefined);
                } },
                React.createElement(core_1.ListItemIcon, null,
                    React.createElement(Icon, null)),
                React.createElement(core_1.Typography, null,
                    "\u3048\u3093\u3074\u3064\u306E\u30B5\u30A4\u30BA ",
                    size)));
        })),
        React.createElement(IconButton_1.IconButton, { active: cursorMode === 'eraser', label: "\u6D88\u3057\u30B4\u30E0", margin: true, onClick: handleEraser }, eraserWidth === 1 ? (React.createElement(Eraser1_1.default, null)) : eraserWidth === 2 ? (React.createElement(Eraser2_1.default, null)) : eraserWidth === 3 ? (React.createElement(Eraser3_1.default, null)) : eraserWidth === 4 ? (React.createElement(Eraser4_1.default, null)) : eraserWidth === 5 ? (React.createElement(Eraser5_1.default, null)) : (React.createElement(Eraser_1.default, null))),
        React.createElement(core_1.Menu, { open: Boolean(eraserAnchorEl), anchorEl: eraserAnchorEl, onClose: function () { return setEraserAnchorEl(undefined); } }, NibIcons.map(function (Icon, size) {
            return size === 0 ? null : (React.createElement(core_1.MenuItem, { key: size, selected: eraserWidth === size, onClick: function () {
                    setEraserWidth(size);
                    setEraserAnchorEl(undefined);
                } },
                React.createElement(core_1.ListItemIcon, null,
                    React.createElement(Icon, null)),
                React.createElement(core_1.Typography, null,
                    "\u6D88\u3057\u30B4\u30E0\u306E\u30B5\u30A4\u30BA ",
                    size)));
        })),
        React.createElement(IconButton_1.IconButton, { active: cursorMode === 'base', label: "\u3058\u3081\u3093", margin: true, onClick: handleBase },
            React.createElement(FormatPaint_1.default, null)),
        React.createElement(IconButton_1.IconButton, { active: cursorMode === 'dropper', label: "\u30B9\u30DD\u30A4\u30C8", margin: true, onClick: handleDropper },
            React.createElement(Colorize_1.default, null))));
}
exports.MenuBar = MenuBar;
//# sourceMappingURL=MenuBar.js.map